<template>
  <el-form
      ref="form"
      :model="form"
      :rules="rules"
      :label-position="labelPosition"
      label-width="160px"
  >
    <el-form-item
        label="Line频道id"
        prop="channelId"
    >
      <el-input
          placeholder="请输入"
          v-model="form.channelId"
      ></el-input>
    </el-form-item>
    <el-form-item
        label="Line频道名称"
        prop="channelName"
    >
      <el-input
          placeholder="请输入"
          v-model="form.channelName"
      ></el-input>
    </el-form-item>
    <el-form-item
        label="密钥"
        prop="channelSecret"
    >
      <el-input
          placeholder="请输入"
          v-model="form.channelSecret"
      ></el-input>
    </el-form-item>
    <el-form-item
        label="接口调用凭证"
        prop="accessToken"
    >
      <el-input
          placeholder="请输入"
          v-model="form.accessToken"
      ></el-input>
    </el-form-item>
    <el-form-item
        label="备注"
        prop="remark"
    >
      <el-input
          type="textarea"
          placeholder="请输入"
          v-model="form.remark"
          :rows="3"
          resize="none"
      ></el-input>
    </el-form-item>

    <el-form-item
      label="状态"
      prop="status"
    >
      <el-radio
        v-model="form.status"
        :label="1"
      >启用</el-radio>
      <el-radio
          v-model="form.status"
          :label="0"
      >禁用</el-radio>
    </el-form-item>
  </el-form>
</template>

<script>
import formLabalPosition from "@/mixins/formLabalPosition";
let originForm = {
  channelId: '',
  channelName: '',
  channelSecret: '',
  accessToken: '',
  remark: '',
  status: 1,
}
export default {
  name: "lineForm",
  components:{
  },
  props: {
    formData:{
      type: Object,
      default(){
        return {
          ...originForm,
        }
      }
    },
  },

  data() {
    return {
      form: {
        ...originForm,
      },
      rules:{
        channelId: [
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        channelName:[
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        channelSecret:[
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        accessToken:[
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        remark:[
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        status:[
          { required: true, message: '请输入', trigger: 'change' },
        ],
      },
    }
  },
  computed: {

  },
  mixins: [formLabalPosition],
  watch:{
    formData:{
      handler(newVal,oldVal){
        if(newVal){
            this.assign(newVal);
        }
      },
      deep:true,
    },
  },
  created(){
    console.log(this.formData)
      if(this.formData.id){
          this.assign(this.formData);
      }
  },
  methods:{
      assign(formData){
          this.form.id = formData.id;
          this.form.channelId = formData.channelId;
          this.form.channelName = formData.channelName;
          this.form.channelSecret = formData.channelSecret;
          this.form.accessToken = formData.accessToken;
          this.form.remark = formData.remark;
          this.form.status = formData.status;
      },
    reset(){
      this.form = {
        ...originForm,
      };
    },
    validate(){
      this.$refs.form.validate((valid) => {
        if(valid){
          this.$emit('submit',this.form);
        }else {
          console.log('no-pass')
        }
      })
    },
  },
}
</script>

<style scoped>

</style>
